import React__default from 'react';
import { EditUserProfileProvider } from './EditUserProfile/context.js';
import { EditUserProfileUI } from './EditUserProfile/components/EditUserProfileUI.js';
import './chunks/bundle-CxLxJCBu.js';
import './useSendbirdStateContext.js';
import './withSendbird.js';
import './chunks/bundle-d1cOX5nv.js';
import './chunks/bundle-DS1EhNtb.js';
import './chunks/bundle-D9MeorzH.js';
import './chunks/bundle-DRpjMk0B.js';
import './chunks/bundle-BA9oFJ90.js';
import '@sendbird/chat/groupChannel';
import './utils/message/getOutgoingMessageState.js';
import './chunks/bundle-DiK8ifY3.js';
import './chunks/bundle-C-nZYnmy.js';
import './chunks/bundle-DP3z2QNm.js';
import './chunks/bundle-kFa80LJe.js';
import 'react-dom';
import './chunks/bundle-Ci-RNuvu.js';
import './ui/IconButton.js';
import './ui/Button.js';
import './chunks/bundle-CjJk57u5.js';
import './ui/Icon.js';
import '@sendbird/uikit-tools';
import 'css-vars-ponyfill';
import '@sendbird/chat';
import './chunks/bundle-DKdROCX_.js';
import '@sendbird/chat/openChannel';
import './chunks/bundle-DdJ9pMWn.js';
import './chunks/bundle-BzR1dD25.js';
import './ui/SortByRow.js';
import './ui/Input.js';
import './chunks/bundle-DOfhjbKd.js';
import './ui/ImageRenderer.js';
import './chunks/bundle-C_zEpfCP.js';
import './ui/TextButton.js';
import './chunks/bundle-B5157rdG.js';

var EditUserProfile = function (props) {
    var onEditProfile = props.onEditProfile, onCancel = props.onCancel, onThemeChange = props.onThemeChange;
    return (React__default.createElement(EditUserProfileProvider, { onEditProfile: onEditProfile, onCancel: onCancel, onThemeChange: onThemeChange },
        React__default.createElement(EditUserProfileUI, null)));
};

export { EditUserProfile as default };
//# sourceMappingURL=EditUserProfile.js.map
